import { render } from "./Services.vue?vue&type=template&id=9c4dbb24"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"

import "./Services.vue?vue&type=style&index=0&id=9c4dbb24&lang=scss"
script.render = render

export default script